import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ETNotification } from '../notification/model/ETnotification';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-notification-push',
  templateUrl: './notification-push.component.html',
  styleUrls: ['./notification-push.component.css']
})
export class NotificationPushComponent implements OnInit {
 @Input() webpush:ETNotification; 
  constructor(
    public sbRef: MatSnackBarRef<NotificationPushComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private router:Router
  ) { }



  ngOnInit() {
    this.webpush = JSON.parse(this.data);

    setTimeout(() => this.sbRef.dismiss() ,4000)
  }
  navigate(link:string){
    //console.log(link.substr(link.indexOf(link.split('/')[3])));
    this.router.navigateByUrl(link.substr(link.indexOf(link.split('/')[3])));
  }
}
